import { makeStyles, MenuItem, tokens } from "@fluentui/react-components";
import { Link } from "react-router-dom";

interface IMenuItemLinkProps {
    to: string;
    label: string;
}

const useStyles = makeStyles({
    root: {
        padding: 0
    },
    link: {
        textDecoration: "none",
        color: "inherit",
        display: "block",
        width: "100%",
        textAlign: "left",
        padding: tokens.spacingVerticalSNudge
    }
});

const MenuItemLink = (props: IMenuItemLinkProps) => {
    const { to, label } = props;
    const styles = useStyles();

    return (
        <MenuItem className={styles.root}>
            <Link to={to} className={styles.link}>{label}</Link>
        </MenuItem>
    );
};

export default MenuItemLink;